// extracted by mini-css-extract-plugin
export default {"root":"LandingLayout_root__wzB+y","container":"LandingLayout_container__EHyWN","content":"LandingLayout_content__6mZJF","sidebar":"LandingLayout_sidebar__Q993l"};